export function Range(start: number, end: number): number[] {
    return Array.from({ length: Math.abs(end - start) + 1 }, (value, index) => start + index * Math.sign(end - start));
}

export const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));
